import React from "react";
import { Box, Skeleton } from "@mui/material";

// Shaped like the real card grid (same 6-column layout, same 12px radius) so the
// loading state previews what's about to render, instead of an unrelated placeholder.
const CardsSkeleton = () => (
  <Box
    sx={{
      display: "grid",
      gridTemplateColumns: "repeat(6, minmax(0, 1fr))",
      columnGap: "24px",
      rowGap: "24px",
      width: "100%",
    }}
  >
    {Array.from({ length: 6 }).map((_, index) => (
      <Skeleton key={index} variant="rounded" sx={{ borderRadius: "12px", height: "94px" }} />
    ))}
  </Box>
);

export default CardsSkeleton;
